import { Card, CardBody, Eyebrow, FormField, Input } from '@/shared/components';
import type { InvoiceTemplateForm } from './invoiceTemplateForm';

interface Props {
  form: InvoiceTemplateForm;
  isEdit: boolean;
  set: (patch: Partial<InvoiceTemplateForm>) => void;
}

/** Bezeichnung und Absenderdaten — die linke Spalte des Editors. */
export function InvoiceTemplateSenderFields({ form, isEdit, set }: Props) {
  return (
    <Card>
      <CardBody className="p-5">
        <Eyebrow variant="muted">Bezeichnung</Eyebrow>
        <div className="mt-3 space-y-4">
          <FormField
            label="Name der Vorlage"
            required
            hint="Nur intern — steht nie auf der Rechnung."
          >
            <Input value={form.name} onChange={(e) => set({ name: e.target.value })} />
          </FormField>
          {!isEdit && (
            <label className="flex min-h-11 cursor-pointer items-center gap-3">
              <input
                type="checkbox"
                className="accent-sage h-4 w-4"
                checked={form.isPrimary}
                onChange={(e) => set({ isPrimary: e.target.checked })}
              />
              <span className="text-ink text-sm">Als Standardvorlage des Workspace verwenden</span>
            </label>
          )}
        </div>

        <Eyebrow variant="muted" className="mt-6">
          Absender
        </Eyebrow>
        <p className="text-ink-soft mt-1 text-xs">
          Automatische Rechnungen brauchen Firmenname, vollständige Anschrift mit Land und
          Steuernummer oder USt-IdNr. Fehlt etwas davon, warten sie, bis es ergänzt ist.
        </p>
        <div className="mt-3 space-y-4">
          <FormField label="Firmenname">
            <Input
              value={form.companyName}
              onChange={(e) => set({ companyName: e.target.value })}
            />
          </FormField>
          <FormField label="Straße und Hausnummer">
            <Input
              value={form.billingStreet}
              onChange={(e) => set({ billingStreet: e.target.value })}
            />
          </FormField>
          <div className="grid grid-cols-3 gap-3">
            <FormField label="PLZ">
              <Input
                value={form.billingPostalCode}
                onChange={(e) => set({ billingPostalCode: e.target.value })}
              />
            </FormField>
            <FormField label="Ort" className="col-span-2">
              <Input
                value={form.billingCity}
                onChange={(e) => set({ billingCity: e.target.value })}
              />
            </FormField>
          </div>
          <FormField label="Land">
            <Input
              value={form.billingCountry}
              onChange={(e) => set({ billingCountry: e.target.value })}
            />
          </FormField>
          <div className="grid gap-3 sm:grid-cols-2">
            <FormField label="Steuernummer">
              <Input value={form.taxNumber} onChange={(e) => set({ taxNumber: e.target.value })} />
            </FormField>
            <FormField label="USt-IdNr.">
              <Input value={form.vatId} onChange={(e) => set({ vatId: e.target.value })} />
            </FormField>
          </div>
          <div className="grid gap-3 sm:grid-cols-2">
            <FormField label="E-Mail">
              <Input
                type="email"
                value={form.contactEmail}
                onChange={(e) => set({ contactEmail: e.target.value })}
              />
            </FormField>
            <FormField label="Telefon">
              <Input
                type="tel"
                value={form.contactPhone}
                onChange={(e) => set({ contactPhone: e.target.value })}
              />
            </FormField>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
